import localForage from 'localforage';
export class KvStorageImpl {
    storage;
    constructor(driver, name) {
        this.storage = localForage.createInstance({
            driver,
            name,
            storeName: 'LucidSdk',
            description: 'key-value storage',
        });
    }
    put(key, value) {
        return this.storage.setItem(key, value).then(() => { });
    }
    get(key) {
        return this.storage.getItem(key);
    }
    remove(key) {
        return this.storage.removeItem(key);
    }
    clear() {
        return this.storage.clear();
    }
}
